import { CognitoUserPool } from 'amazon-cognito-identity-js';
const POOL_DATA = {
    UserPoolId: 'us-west-1_Vlbs3NfqL',
    ClientId: '51s6s1gt7gg92l7o2614adpl7i',
}

export const UserPool = new CognitoUserPool(POOL_DATA);